import { FieldSchema } from './FieldSchema';
import { PlayerSchema } from './PlayerSchema';

export const GameStateSchema: FieldSchema = {
	type: 'object',
	fields: {
		initPlayerTableOrder: { type: 'number[]' },
		currentTurnTypePlayerTableOrder: { type: 'number[]' },
		turnOrder: { type: 'number[]' },

		numPlayers: { type: 'number' },
		activePlayerId: { type: 'number' },
		monthTracker: { type: 'number' },
		seasonTracker: { type: 'number' },
		carbonReservoir: { type: 'number' },

		turnType: { type: 'string' },
		singlePlayer: { type: 'boolean' },

		game_id_server: { type: 'number' },
		gameStatus: { type: 'number' },

		worldEnergy: {
			type: 'object',
			fields: {
				red: { type: 'number' },
				green: { type: 'number' },
				blue: { type: 'number' },
				yellow: { type: 'number' },
				carbon: { type: 'number' },
			},
		},

		DeckSS: { type: 'number[]' },
		DeckFW: { type: 'number[]' },
		DeckNews: { type: 'number[]' },
		DeckSummit: { type: 'number[]' },

		seasonalNewsCards: { type: 'number[]' },

		triggers: { type: 'string[]' },

		decisionPlayerId: { type: 'number' },
		decisionCardId: { type: 'number' },
		decisionChoiceArr: { type: 'string[]' },
		decisionSourceArr: { type: 'string[]' },
		decisionTargetArr: { type: 'string[]' },

		isSummit: { type: 'boolean' },
		isSummitWinter: { type: 'boolean' },

		summitDraftPlayerIds: { type: 'number[]' },
		summitDraftCardIds: { type: 'number[]' },
		summitDraftCardIdArrForDepth: { type: 'number[]' },
		summitDraftCardIdForPlayer: { type: 'number[]' },

		/* Always at the bottom */
		playerStateArray: {
			type: 'object[]',
			fields: PlayerSchema.fields,
		},
	},
};
